
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Tracking label='content25' mdxType="Tracking" />
    <p>{`Auch das Kleine hat die Naturwissenschaft entzaubert. Die Entwicklung von
Mikroskopen erhöhte die Sichtbarkeit des einst Unsichtbaren bis auf
Tausendstelmillimeter. Was kleiner war, wurde durch Modelle entschlüsselt. Ein
Proton? Elektrisch positiv geladenes Teilchen, zusammen mit Elektron und Neutron
Baustein eines Atoms. Mehrere Atome bilden zusammen die Materie.`}</p>
    <p>{`Zum Beispiel einen Leinenstoff wie das Grabtuch von Turin. Angeblich war Jesus
nach der Kreuzigung damit zugedeckt worden – dafür pilgern alle paar Jahre
Tausende von Gläubigen nach Turin, und selbst die Kopie im Museo della Sindone
ist ein Publikumsmagnet. Nun kann man das Alter von Leinen mittels Messung der
Masse seiner Atome inzwischen sehr genau datieren. Die Messungen ergaben für das
Original ein Alter von rund 700 Jahren, womit der Mythos entzaubert wäre – wären
Mythen nicht resistent gegen Fakten.`}</p>
    <p>{`Der Forscher am Mikroskop ist das Idealbild des Wissenschafters: Er ist
unbeteiligter Beobachter und Verfolger des Geschehens, das sich seinem Auge
direkt oder als Abbildung von Elektronen darbietet. Das erkennende Subjekt und
das zu erkennende Objekt sind klar getrennt. Es ist die passende
Versuchsanordnung für eine Forschungsgemeinschaft mit technischem Interesse,
deren Erkenntnisse sich unter Anerkennung gemeinsamer Standards kumulieren.
Unter dem technischen Interesse kann sich der Mensch auch selber untersuchen,
sich in die MRI-Röhre legen, Röntgenstrahlen aussetzen, Gewebeproben oder Viren
unters Mikroskop legen. Nicht mit dem Mikroskop untersuchen kann die
Forschungsgemeinschaft Wesen und Ängste des Menschen, Gefühle, soziale
Beziehungen, Träume, das Unbewusste überhaupt – es sei denn, die
Naturwissenschaft entzaubert auch den Menschen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;